<template>
    <div class="addbyinbound clearfix" style="position: relative">
        <compFormEdit
            ref="editForm"
            v-model="formData"
            :formdata="getBase"
            :data="formData"
        ></compFormEdit>
        <div class="pull-right margin-top-30">
            <Button class="margin-right-15" type="primary" @click="nextStep"
                >下一步</Button
            >
            <Button type="default" @click="cancel">取消</Button>
        </div>
        <compModal v-model="operate.show" v-bind="operate">
            <component
                :is="operate.component"
                v-bind="operate.props"
                v-on="operate.on"
            ></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import ajaxMixin from "../ajaxmixin";
import compInbound from "../inbound";
import {
    HttpAddByInboundPlan
} from "@/service/transferplan";
export default {
    mixins: [ajaxMixin],
    components: {
        compInbound
    },
    data () {
        return {
            formData: {
                orgWarehouseId: 1
            },
            rowData: {},
            operate: {
                show: false
            },
            loading: false
        }
    },
    computed: {
        getBase () {
            return [
                {
                    label: "入库计划单",
                    key: "id",
                    tag: "div",
                    // tag: "vInput",
                    required: true,
                    children: (h) => {
                        return <Input value={this.rowData.inboundPlanOrderNo} readonly>
                            <Icon style="cursor: pointer;" slot="suffix" type="md-search" nativeOnClick={this.handleChooseInbound.bind(this)}></Icon>
                        </Input>
                    },
                    style: "margin-bottom: -2px;"
                },
                {
                    label: "转运仓库",
                    key: "orgWarehouseId",
                    tag: "vSelect",
                    options: this.mixinWarehouseList,
                    required: true
                },
                {
                    label: "目的地",
                    key: "receiveCode",
                    tag: "vSelect",
                    options: this.mixinDestinationList,
                    required: true
                },
                {
                    label: "期望到仓日期",
                    key: "expectArriveTime",
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd"
                    },
                    required: true
                },
                {
                    label: "备注",
                    key: "remark",
                    tag: "vTextarea",
                    required: false
                }
            ]
        },
    },
    methods: {
        handleChooseInbound () {
            this.operate = {
                show: true,
                title: "查找入库计划",
                component: "compInbound",
                width: 800,
                showFooter: false,
                on: {
                    'on-select': (row) => {
                        this.rowData = row;
                        this.operate.show = false;
                    }
                }
            }
        },
        async nextStep () {
            await this.$refs.editForm.validate();
            this.loading = true;
            await HttpAddByInboundPlan({
                id: this.rowData.id,
                ...this.formData
            }).then(res => {
                this.$router.push({
                    name: 'transferPlanUpdate',
                    params: { type: "edit" },
                    query: { id: res.data.id },
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        cancel () {
            this.$emit('on-close');
        },
    }
}
</script>

<style>
</style>